
define('app/users/registerMain',[
	'domReady',
	'app/users/registerApp',
	'app/common/setup',
	'unknown/unknownSetup'
], function(domReady, RegisterApp, Setup, UnknownSetup){
	domReady(function () {
		Setup.initialize();
		RegisterApp.initialize();
		UnknownSetup.initialize();
    });
});